import { React, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import notification from 'antd/es/notification';
import Button from 'antd/es/button';
import './style.less';
import { stateID, UserTypeDict } from '../../../utils/settings';

import {
  getEditRequestsAction,
  getIsFMCG,
  GetMeAction,
  UpdateuserNow,
} from '../action';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import '../../../translations/i18n';
import ScreenBack from '../../../components/screenBack/screenBack';
import Sidebar from '../../distributor/view/component/Sidebar/Sidebar';
import Navbar from '../../distributor/view/navbar/navbar';
import { Select } from 'antd';
import {
  GetAllCityOfState,
  GetAllStates,
  GstUserGstDataFetch,
  GstUserPanDataFetch,
} from '../action/util_actions';
import { checkingForOnlyErrorNotification } from '../../../utils/utilFuntions';
import { useForm } from 'antd/es/form/Form';
const isFMCG = getIsFMCG();

const { Option } = Select;

const EditProfile = () => {
  const { t } = useTranslation();
  const [form] = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State and city dropdowns
  const [distArr, setDistArr] = useState([]);
  const [companyType, setcompanyType] = useState();
  const [stateArr, setStateArr] = useState(new Array());
  const [currentStateId, setCurrentStateId] = useState(-1);

  const [typeOptions, setTypeOptions] = useState([]);

  // Edit Request Checking
  const [editRequestPending, setEditRequestPending] = useState([]);

  const citySelectref = useRef();

  const { loginUser, isPaint } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      isPaint: state.loginReducer.isPaint,
    };
  });

  useEffect(() => {
    setcompanyType(loginUser.company_details.company_type);
    setCurrentStateId(loginUser.company_details.district_id.state.id);
  }, []);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const GetAllStatesEffect = async () => {
      await GetAllStates().then((states) => {
        let { error, data } = states;
        if (!error && data) {
          setStateArr(data);
        }
      });
    };

    GetAllStatesEffect();
  }, []);

  const companyTypeChange = (e) => {
    setcompanyType(e);
  };

  useEffect(() => {
    const GetAllCityOfStateEffect = async () => {
      if (loginUser.company_details.district_id.state.id >= 0) {
        await GetAllCityOfState(
          currentStateId >= 0
            ? currentStateId
            : loginUser.company_details.district_id.state.id,
        )
          .then((districts) => {
            setDistArr(districts);
            let { error, data } = districts;
            if (!error && data) {
              setDistArr(data);
              citySelectref.current.value = data[0].district_name;
            }
          })
          .catch();
      }
    };

    GetAllCityOfStateEffect();
  }, [currentStateId]);

  useEffect(() => {
    if (!loginUser) {
      navigate('/login');
    }
  }, [loginUser]);

  const onFinishHandler = async (value) => {
    const obj = {
      user_phone_number: loginUser.phone_number,
      id: loginUser.id,
      firstname: value.firstname,
      lastname: value.lastname,
      pancard_no: value.pancard_no.toUpperCase(),
      // email: value.email,
      company_name: value.company_name,
      company_type: value.company_type,
      company_address: value.street,
      company_pincode: value.company_pincode,
      district_id: value.city,
      company_gstin: value.company_gstin
        ? value.company_gstin.toUpperCase()
        : null,
    };

    if (companyType === UserTypeDict['RETAILER'] && value.company_gstin) {
      let regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
      let findVal = value.company_gstin.match(regex);

      if (findVal === null) {
        notification.error({
          message: 'Error',
          description: 'Wrong Gst Number',
        });
        return;
      }
      if (findVal.input) {
        obj.company_gstin = value.company_gstin.toUpperCase();
      }
    }

    setLoader(true);

    const { error, message } = await UpdateuserNow(obj);

    setLoader(false);
    if (error) {
      notification.error({
        message: 'Error',
        description: message,
      });
      return;
    }
    let { error: userError, data: loggedInUser } = await GetMeAction();
    //
    if (!userError && loggedInUser) {
      dispatch({ type: 'SET_USER', data: loggedInUser });
      localStorage.setItem('user', JSON.stringify(loggedInUser));
      navigate('/');
    }
  };

  //Filtered UserType arr to only contain Retailer and Distributor
  const UserTypeArr = [
    { name: t('userType.DEALER_RETAILER'), id: 6, type: 6 },
    { name: t('userType.DISTRIBUTOR'), id: 2, type: 2 },
    { name: t('userType.RETAILER'), id: 3, type: 3 },
    { name: 'Associate', id: 8, type: 8 },
  ];

  const tempGujCompanyTypes = [
    { name: 'Dealer', id: 3, type: 3 },
    { name: 'Distributor', id: 2, type: 2 },
    { name: 'Associate', id: 8, type: 8 },
  ];
  const fmcgCompanyTypes = [
    { name: 'Retailer', id: 3, type: 3 },
    { name: 'Distributor', id: 2, type: 2 },
  ];

  useEffect(() => {
    //Removed the check for stateID.includes(currentStateId) for role selection
    // const TypeArr = stateID.includes(currentStateId)
    //   ? tempGujCompanyTypes.map((state) => (
    //       <Option key={state.id} value={state.id}>
    //         {state.name}
    //       </Option>
    //     ))
    //   : UserTypeArr.map((state) => (
    //       <Option key={state.id} value={state.id}>
    //         {state.name}
    //       </Option>
    //     ));

    const TypeArr = tempGujCompanyTypes.map((state) => (
      <Option
        key={state.id}
        value={state.id}
      >
        {state.name}
      </Option>
    ));
    const FMCGTypeArr = fmcgCompanyTypes.map((state) => (
      <Option
        key={state.id}
        value={state.id}
      >
        {state.name}
      </Option>
    ));

    setTypeOptions(!isFMCG ? TypeArr : FMCGTypeArr);
  }, [currentStateId]);

  const stateOptions =
    stateArr.length > 0
      ? stateArr.map((state) => ({ label: state.state_name, value: state.id }))
      : [];

  const districtOptions =
    distArr.length > 0
      ? distArr.map((district) => ({
          label: district.district_name,
          value: district.id,
        }))
      : [];

  // --------- Check if any request Pending -----------------------
  const checkIfRequestPending = async () => {
    setLoader(true);
    const { error, message, data } = await getEditRequestsAction();
    setLoader(false);

    if (!error) {
      setEditRequestPending(data);
      if (data.length > 0) {
        notification.warn({
          message: 'You have pending Edit request already',
          duration: 10,
        });
      }
    } else {
      notification.error({ message });
    }
  };

  useEffect(() => {
    checkIfRequestPending();
  }, []);

  const onGstBlur = async (e) => {
    const value = e.target.value;
    let regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
    let findVal = regex.exec(value);
    if (findVal === null) {
      return;
    }

    const { error, message, data } = await GstUserGstDataFetch(value);

    checkingForOnlyErrorNotification(error, message);

    if (!error && Object.keys(data).length) {
      const firstname = data.directors
        ? data?.directors[0]?.split(' ')[0]
        : null;
      const lastname = data.directors
        ? data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ').length ===
          3
          ? data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')[2]
          : data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')[1]
        : null;

      form.setFieldsValue({
        pancard_no: data?.pan,
        firstname: firstname,
        lastname: lastname,
        company_name: data?.trade_name,
        street: data?.principal_address?.address,
      });
    }
  };

  const onPanBlur = async (e) => {
    const value = e.target.value;
    let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
    let findVal = regex.exec(value);
    if (findVal === null) {
      return;
    }

    const { error, message, data } = await GstUserPanDataFetch(value);
    checkingForOnlyErrorNotification(error, message);

    if (!error) {
      const firstname = data?.first_name && data?.first_name;
      const lastname = data?.last_name && data?.last_name;

      form.setFieldsValue({
        firstname: firstname,
        lastname: lastname,
        company_pincode:
          data?.address_data &&
          data?.address_data?.pincode &&
          data?.address_data?.pincode,
        street:
          data?.address_data &&
          data?.address_data?.line_1 &&
          data?.address_data?.line_1,
      });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div
        className='container'
        style={{ flex: 1 }}
      >
        <Navbar />
        <div className='marginContainer'>
          <ScreenBack />
          <div
            className={'onboarding'}
            style={{ flexDirection: 'column' }}
          >
            <div className={'onboarding-header'}>
              {/*<div className={"welcome-text"}>{t("onboarding.nowUAre")}</div>*/}
              <div className={'screen-title'}>{t('profile.editProfile')}</div>
            </div>
            {editRequestPending.length > 0 && (
              <div
                className='displayCenter'
                style={{
                  width: '100%',
                  margin: '2rem 0',
                  padding: '0.5rem 0',
                  fontSize: '1rem',
                  color: 'orange',
                  border: '1px dashed orange',
                  borderStyle: 'dashed dashed dashed dashed',
                }}
              >
                You have pending Edit request already
              </div>
            )}
            <Form
              ref={citySelectref}
              layout={'vertical'}
              name={'onboarding'}
              form={form}
              autoComplete='off'
              onFinish={onFinishHandler}
              initialValues={{
                firstname: loginUser.firstname,
                lastname: loginUser.lastname,
                company_gstin: loginUser.company_details.gstin,
                pancard_no: loginUser.company_details.pancard_no,
                email: loginUser.email,
                company_name: loginUser.company_details.name,
                company_type: loginUser.company_details.company_type,
                state: loginUser.company_details.district_id.state.id,
                street: loginUser.company_details.address,
                company_pincode: loginUser.company_details.pincode,
                city: loginUser.company_details.district_id.id,
              }}
            >
              <Form.Item
                label={t('onboarding.firstName')}
                name={'firstname'}
                rules={[
                  {
                    message: t('onboarding.noFirstName'),
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder={t('onboarding.firstName')}
                  // defaultValue={loginUser.firstname}
                />
              </Form.Item>
              <Form.Item
                label={t('onboarding.lastName')}
                name={'lastname'}
                rules={[
                  {
                    message: t('onboarding.noLastName'),
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t('onboarding.lastName')}></Input>
              </Form.Item>
              {/* <Form.Item label={t("register.email")} name={"email"}>
                <Input placeholder={t("register.emailPlaceholder")}></Input>
              </Form.Item> */}
              <Form.Item
                label={t('onboarding.gstNo')}
                name={'company_gstin'}
                rules={[
                  {
                    message: t('onboarding.noGstNo'),
                    required:
                      companyType === UserTypeDict['RETAILER']
                        ? // companyType === UserTypeDict["DEALER_RETAILER"]
                          false
                        : true,
                  },
                  companyType === UserTypeDict['RETAILER']
                    ? // companyType === UserTypeDict["DEALER_RETAILER"]
                      {}
                    : {
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject('GST number is mandatory');
                          }
                          if (value.length === 15) {
                            let regex =
                              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
                            let findVal = regex.exec(value);
                            if (findVal === null) {
                              return Promise.reject('Wrong GST input');
                            }
                            if (findVal.input) {
                              return Promise.resolve();
                            }
                          } else {
                            return Promise.reject(
                              'GST number should be of 15 digit',
                            );
                          }
                        },
                      },
                ]}
              >
                <Input
                  onBlur={onGstBlur}
                  placeholder={t('onboarding.pleaseGstDetails')}
                ></Input>
              </Form.Item>
              <Form.Item
                label={t('onboarding.panNo')}
                name={'pancard_no'}
                rules={[
                  {
                    message: t('onboarding.noPanNo'),
                    required: true,
                  },
                  {
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject('PAN number is mandatory');
                      }
                      if (value.length === 10) {
                        let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
                        let findVal = regex.exec(value);
                        if (findVal === null) {
                          return Promise.reject('Wrong PAN Number Input');
                        }
                        if (findVal.input) {
                          return Promise.resolve();
                        }
                      } else {
                        return Promise.reject(
                          'PAN number should be of 10 digit',
                        );
                      }
                    },
                  },
                ]}
              >
                <Input
                  onBlur={onPanBlur}
                  placeholder={t('onboarding.pleasePanDetails')}
                ></Input>
              </Form.Item>
              <Form.Item
                label={t('onboarding.yourCompanyName')}
                name={'company_name'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noCompanyName'),
                  },
                ]}
              >
                <Input placeholder={t('onboarding.companyName')}></Input>
              </Form.Item>
              <Form.Item
                label={t('onboarding.registeredAs')}
                name={'company_type'}
                rules={[
                  {
                    required: true,
                    message: t('onboarding.noRegisteredAs'),
                  },
                ]}
              >
                <Select
                  placeholder={t('userType.RETAILER')}
                  className={'registerSelector'}
                  onChange={companyTypeChange}
                  disabled={isFMCG || isPaint}
                >
                  {typeOptions}
                </Select>
              </Form.Item>
              <Form.Item
                name='street'
                label={t('address')}
                rules={[{ required: true, message: 'Enter Street Address' }]}
              >
                <Input placeholder={t('onboarding.streetAddress1')} />
              </Form.Item>
              <Form.Item
                label={t('onboarding.companyAddress')}
                style={{ marginBottom: 0 }}
              >
                <Form.Item
                  name='state'
                  label={t('onboarding.state')}
                  rules={[{ required: true, message: 'State is mandatory' }]}
                  // style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                >
                  <Select
                    // disabled={true}
                    showSearch
                    placeholder={t('onboarding.state')}
                    onChange={(e) => setCurrentStateId(e)}
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={stateOptions}
                  />
                </Form.Item>
                <Form.Item
                  name='city'
                  label={t('onboarding.district')}
                  rules={[{ required: true, message: 'City is Mandatory' }]}
                >
                  <Select
                    // value={distArr && distArr[0]?.id}
                    placeholder={t('onboarding.district')}
                    showSearch
                    // onChange={handleDistrictChange}
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={districtOptions}
                  />
                </Form.Item>
              </Form.Item>
              <Form.Item
                name='company_pincode'
                label={t('pincode')}
                rules={[{ required: true, message: 'Enter Company Pincode' }]}
              >
                <Input
                  placeholder={t('onboarding.postalCode')}
                  maxLength={6}
                  minLength={6}
                  inputMode={'numeric'}
                  onKeyPress={(e) => {
                    const key = e.key;
                    if (
                      (key !== '.' && isNaN(key)) ||
                      (key === '.' && e.target.value.includes('.'))
                    ) {
                      e.preventDefault();
                    }
                  }}
                  // onBlur={onPincodeBlur}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  loading={loader}
                  block={true}
                  className={'btn'}
                  type='primary'
                  htmlType='submit'
                >
                  <b className={'btnText'}>{t('update')}</b>
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
